<template>
  <router-view></router-view>
</template>

<script>
  export default {
  }
</script>
<style>

  /* esri styles */
  /* @import url('https://js.arcgis.com/4.10/esri/css/main.css'); */
  /* @import url('https://js.arcgis.com/4.18/esri/themes/light/main.css'); */
  @import url('https://js.arcgis.com/4.19/esri/themes/light/main.css');

</style>

<style src="../node_modules/handsontable/dist/handsontable.full.css"></style>
